import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { UserInfo, useRoomStore } from '../../../../stores/room';
import { ICON_NAME } from '../../../../constants/icon';
import { Message } from 'element-ui';
import TUIRoomCore, { ETUIRoomRole, ETUISpeechMode } from '../../../tui-room-core';
import { useBasicStore } from '../../../../stores/basic';
import { MESSAGE_DURATION } from '../../../../constants/message';
import SvgIcon from '../../common/SvgIcon.vue';
import useMasterApplyControl from '../../../hooks/useMasterApplyControl';
import {storeToRefs} from "pinia";
import {LIVE_STAGE} from "@/constants/room";
import StringUtils from "@/putils/StringUtils";
import {USER_ROLE_MAJOR} from "@/constants/localKeys";
import {LAYOUT} from "@/constants/render";
import logger from "@/TUIRoom/tui-room-core/common/logger/logs";

interface Props {
  userInfo: UserInfo,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'memberControl',
  props: {
    userInfo: null
  },
  setup(__props: any) {

const props = __props as {
  userInfo: UserInfo,
}

const basicStore = useBasicStore();
const roomStore = useRoomStore();
// 举手发言功能相关函数
const {
  agreeUserOnStage,
  denyUserOnStage,
  handleUserApply,
  inviteUserOnStage,
  cancelInviteUserOnStage,
  kickUserOffStage,
} = useMasterApplyControl();

const { userList,localStream } = storeToRefs(roomStore);


const { userId, userRole, shareUserId,shareUserSig, screenProfile, liveStageRoom } = storeToRefs(basicStore);
const showMoreControl = ref(false);
const isMe = computed(() => basicStore.userId === props.userInfo.userId);
const isAnchor = computed(() => props.userInfo.role === ETUIRoomRole.ANCHOR);
const isAudience = computed(() => props.userInfo.role === ETUIRoomRole.AUDIENCE);
const isApplyRoomMode = computed(() => basicStore.roomMode === ETUISpeechMode.APPLY_SPEECH);

// 控制元素的集中匹配情况

// 自由发言模式
// 1.当前用户为主播：
// 禁言/解除禁言  禁画/解除禁画
//              禁止聊天
//              踢出房间

// 举手发言模式
// 1. 当前用户为主播：
// 禁言/解除禁言  禁画/解除禁画
//              邀请下线
//              禁止聊天
//              踢出房间

// 2. 观众没有申请上麦：
// 邀请上台/取消邀请上台      禁止聊天
//                         踢出房间

// 3. 观众正在申请上麦：
// 同意上台       拒绝上台
//              禁止聊天
//              踢出房间

// 4.授予主播权限
//            授予权限
//            收回授权

const singleControl = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const control = { title: '', func: (userInfo: UserInfo, screenProfile:any) => {} };
  if (isAnchor.value) {
    control.title = props.userInfo.isAudioMutedByMaster ? '解除禁言' : '禁言';
    control.func = muteUserAudio;
  } else if (isAudience.value) {
    if (props.userInfo.isUserApplyingToAnchor) {
      control.title = '同意上台';
      control.func = agreeUserOnStage;
    } else {
      control.title = props.userInfo.isInvitingUserToAnchor ? '取消邀请上台' : '邀请上台';
      control.func = toggleInviteUserOnStage;
    }
  }
  return control;
});

const denyOnStage = { title: '拒绝上台', func: denyUserOnStage };
const makeOffStage = { title: '邀请下线', func: kickUserOffStage2 };

const videoControlTitle = computed(() => (props.userInfo.isVideoMutedByMaster ? '解除禁画' : '禁画'));
const videoControl = computed(() => ({ title: videoControlTitle.value, func: muteUserVideo }));

const chatControlTitle = computed(() => (props.userInfo.isChatMutedByMaster ? '允许文字聊天' : '禁止文字聊天'));
const forbidChat = computed(() => ({ title: chatControlTitle.value, func: muteUserChat }));

const kickUser = { title: '踢出房间', func: kickOffUser };

const grantAnchor = computed(() => {
  const dataval = { title: '', func: (userInfo: UserInfo, screenProfile:any) => {} };
  if (isAnchor.value) {
    dataval.title = props.userInfo.isGrantAnchor ? '撤销主讲' : '授权主讲';
    dataval.func = muteGrantAnchor;
  }
  return dataval;
});

const controlList = computed(() => {
  const list = [forbidChat.value, kickUser]
  if (isAnchor.value) {
    list.unshift(videoControl.value);
    list.splice(1, 0, grantAnchor.value);
  }
  if (isAnchor.value && isApplyRoomMode.value) {
    list.splice(1, 0, makeOffStage);
  }
  if (isAudience.value && props.userInfo.isUserApplyingToAnchor) {
    list.splice(0, 0, denyOnStage);
  }
  return list;
});


function toggleClickMoreBtn() {
  showMoreControl.value = !showMoreControl.value;
}


// 邀请上台/取消邀请上台
async function toggleInviteUserOnStage(userInfo: UserInfo) {
  const { userId, isInvitingUserToAnchor } = userInfo;
  if (isInvitingUserToAnchor) {
    roomStore.removeInviteToAnchorUser(userId);
    cancelInviteUserOnStage(userInfo);
  } else {
    roomStore.addInviteToAnchorUser(userId);
    inviteUserOnStage(userInfo);
  }
}

// 禁言/取消禁言
function muteUserAudio(userInfo: UserInfo) {
  const currentState = userInfo.isAudioMutedByMaster;
  roomStore.setMuteUserAudio(userInfo.userId, !currentState);
  TUIRoomCore.muteUserMicrophone(userInfo.userId, !currentState);
}

// 禁画/取消禁画
function muteUserVideo(userInfo: UserInfo) {
  const currentState = userInfo.isVideoMutedByMaster;
  roomStore.setMuteUserVideo(userInfo.userId, !currentState);
  TUIRoomCore.muteUserCamera(userInfo.userId, !currentState);
}

// 允许文字聊天/取消文字聊天
function muteUserChat(userInfo: UserInfo) {
  const currentState = userInfo.isChatMutedByMaster;
  roomStore.setMuteUserChat(userInfo.userId, !currentState);
  TUIRoomCore.muteUserChatRoom(userInfo.userId, !currentState);
}

// 授予主讲 授权播放/撤销播放
async function muteGrantAnchor(userInfo: UserInfo) {
  if (liveStageRoom.value != LIVE_STAGE.ONGOING){
    Message({
      type: 'warning',
      message: '直播暂未开始， 不能授权播放',
      duration: MESSAGE_DURATION.LONG,
    });
    return;
  }
  console.log(userInfo)
  const currentState = userInfo.isGrantAnchor;
  roomStore.setMuteGrantAnchor(userInfo.userId, !currentState);
  TUIRoomCore.muteGrantAnchor(userInfo.userId, !currentState);
  //判断用户是否还有其他人授权，循环取消
  let ni = 0;
  for (var i in userList.value){
    if (userList.value[i].userId != userId.value){
      if (userList.value[i].isGrantAnchor  == true  && userList.value[i].userId != userInfo.userId){
        TUIRoomCore.revokeGrantAnchor(userList.value[i].userId,screenProfile);
        roomStore.setMuteGrantAnchor(userList.value[i].userId, false);
        ni++;
      }
    }
  }
  if (currentState == false){
    TUIRoomCore.replyGrantAnchor(userInfo.userId,screenProfile);
  }else{
    TUIRoomCore.delGrantAnchor(userInfo.userId,screenProfile);
  }

  basicStore.setSharingStatus(false);
  if (ni == 0){
    roomStore.setGrantAnchor(true);
  }else {
    roomStore.setGrantAnchor(false);
  }
  if (localStream.value.availableShare == true){
    try {
      await TUIRoomCore.stopScreenShare({
        shareUserId: shareUserId.value,
        shareUserSig: shareUserSig?.value || '',
        screenProfile: screenProfile,
      });
      if (!StringUtils.isObjEqual(userRole,USER_ROLE_MAJOR)) {
        basicStore.setLayout(LAYOUT.TOP_SIDE_LIST);
      }
    } catch (error) {
      logger.error(`撤销播放 停止分享 error:`, error);
    }
    roomStore.setRemoteScreenStream({userId:shareUserId.value,available:false})
  }
}
// 邀请用户下线
function kickUserOffStage2(userInfo: UserInfo) {
  roomStore.setMuteGrantAnchor(userInfo.userId, false);
  console.log("邀请用户下线-------------------",userInfo)
  TUIRoomCore.kickUserOffStage(userInfo.userId);
}

// 将用户踢出房间
function kickOffUser(userInfo: UserInfo) {
  TUIRoomCore.kickOffUser(userInfo.userId);
}


return { __sfc: true,basicStore, roomStore, agreeUserOnStage, denyUserOnStage, handleUserApply, inviteUserOnStage, cancelInviteUserOnStage, kickUserOffStage, userList, localStream, props, userId, userRole, shareUserId, shareUserSig, screenProfile, liveStageRoom, showMoreControl, isMe, isAnchor, isAudience, isApplyRoomMode, singleControl, denyOnStage, makeOffStage, videoControlTitle, videoControl, chatControlTitle, forbidChat, kickUser, grantAnchor, controlList, toggleClickMoreBtn, toggleInviteUserOnStage, muteUserAudio, muteUserVideo, muteUserChat, muteGrantAnchor, kickUserOffStage2, kickOffUser, ICON_NAME, SvgIcon }
}

})